/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Mon Aug 12 2024
 **/

import { atom } from "jotai";

import { IconName } from "@/frameworks/designStuff/components";

import { AlarmLogMessageValueType } from "./types";

/**
 * @description Notification 데이터의 WS와 RestAPI 포멧이 달라, 이를 통일하기 위한 인터페이스
 */
export type NotificationItemPayload<T = unknown> = {
	readKey: string;
	relationId?: string;
} & T;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type NotificationItem<T = any> = {
	id: string;
	type: AlarmLogMessageValueType;
	payload: NotificationItemPayload<T>;
	createdTime: number;
	read: boolean;
};

export type UserInfo = {
	imageSrc: string | undefined;
	colorProfile: string | undefined;
	id: string;
	name: string;
};

export type MyDeskNotificationItem = {
	id: string;
	title: string;
	subTitle?: string;
	createdAt: number;
	roomName?: string;
	meetingName?: string;
	name?: string;
	callId?: string;
	avatar?: {
		name: string;
		imageSrc: string | undefined;
		type: string;
		colorLogo: string | undefined;
	};
	userInfo?: UserInfo;
	isRead: boolean;
	readKey: string;
	icon?: IconName;
	type: string;
	spaceId?: string | undefined;
	groupId?: string | undefined;
	conferenceId?: string;
	chatType?: "ONE_TO_ONE_DM" | "GROUP_DM" | "SPACE";
	approved?: boolean;
};

export type MyDeskNotificationAtomValue = Map<string, NotificationItem>;
export const MyDeskNotificationAtom = atom<MyDeskNotificationAtomValue>(new Map<string, NotificationItem>());
